import { render, staticRenderFns } from "./BasicSwitch.vue?vue&type=template&id=e4369d86&scoped=true&"
import script from "./BasicSwitch.vue?vue&type=script&lang=js&"
export * from "./BasicSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BasicSwitch.vue?vue&type=style&index=0&id=e4369d86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4369d86",
  null
  
)

export default component.exports